import type { Design, ScreenBundle } from './types';

const WEEK = 7 * 24 * 60 * 60 * 1000;

/** True while a scheduled window is running at `now`. Weekly repeats recur from the first start onwards. */
export function isScheduleActive(s: { startsAt: string; durationMinutes: number; repeatWeekly: boolean }, now: Date): boolean {
  const start = Date.parse(s.startsAt);
  if (!Number.isFinite(start)) return false;
  const len = Math.max(1, s.durationMinutes) * 60_000;
  const t = now.getTime();
  if (t < start) return false;
  if (!s.repeatWeekly) return t < start + len;
  return (t - start) % WEEK < len;
}

/** The design a screen should show at `now`: the latest-starting active schedule, else its normal design. */
export function activeDesign(bundle: Pick<ScreenBundle, 'design' | 'schedules'>, now: Date): { design: Design; scheduleId: string | null } {
  const active = bundle.schedules.filter((s) => isScheduleActive(s, now)).sort((a, b) => Date.parse(b.startsAt) - Date.parse(a.startsAt));
  return active[0] ? { design: active[0].design, scheduleId: active[0].id } : { design: bundle.design, scheduleId: null };
}
